// extracted by mini-css-extract-plugin
module.exports = {"productSI":"productSI_productSI__2aPN1","buttons":"productSI_buttons__2mGdu"};